export const build = {
	version: '2.14',
	date: 'Wednesday, 24 July 2024 07:03:56 UTC',
};
